import { AlertCircle, CheckCircle2, Info } from 'lucide-react';
import { cn } from '@/lib/utils';

type NoticeStatus =
  | 'icon-information-outline'
  | 'icon-error-outline'
  | 'icon-circle-checkmark-outline';

interface AlertNoticeProps {
  message: string;
  status?: NoticeStatus;
  className?: string;
}

const iconMap = {
  'icon-information-outline': Info,
  'icon-error-outline': AlertCircle,
  'icon-circle-checkmark-outline': CheckCircle2,
} as const;

function AlertNotice({
  message,
  status = 'icon-information-outline',
  className,
}: AlertNoticeProps) {
  const Icon = iconMap[status] ?? Info;
  const isError = status === 'icon-error-outline';
  const isSuccess = status === 'icon-circle-checkmark-outline';

  return (
    <div
      role={isError ? 'alert' : 'status'}
      className={cn(
        'box-border flex w-full min-w-0 max-w-full items-start gap-2.5 rounded-[10px] border border-solid px-4 py-3 text-sm',
        isError && 'border-[#fecdca] bg-[#fef3f2] text-[#b42318]',
        isSuccess && 'border-[#abefc6] bg-[#ecfdf3] text-[#027a48]',
        !isError &&
          !isSuccess &&
          'border-[var(--inv-border)] bg-[var(--inv-surface-muted)] text-[var(--inv-text-secondary)]',
        className,
      )}>
      <Icon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      <span className="min-w-0 flex-1 break-words">{message}</span>
    </div>
  );
}

export { AlertNotice };
